<template>
  <header>
    <!-- web -->
    <el-row style="height:60px" type="flex" align="middle" justify="space-between">
      <div style="margin-left: 8vw;cursor: pointer;" @click="$routerTo('/Home')">
        <ul style="display: -webkit-inline-box;padding: 0;margin: 0;list-style: none;">
          <li>
            <el-image :src="require('../../public/logo.png')" fit="fit" style="height: 40px;width: 160px;vertical-align: middle;margin-right: 10px"></el-image>
          </li>
        </ul>
      </div>

      <div style="margin-right: 8vw;">
        <el-button @click="drawer = true" size="small" icon="el-icon-s-fold" type="info"></el-button>
      </div>
    </el-row>

    <el-drawer :visible.sync="drawer" direction="rtl" size="50%" :append-to-body="true">
      <el-select style="text-align: center;margin: 10px;" v-model="language" placeholder="語言" @change="languageChange">
        <el-option v-for="item in language_options" :key="item.value" :label="item.label" :value="item.value"></el-option>
      </el-select>

      <div style="margin: 10px;position: absolute;bottom: 0;right: 0;">
        <el-button size="small" @click="showLoginDialog()">後台設定</el-button>
      </div>
    </el-drawer>

    <dialog-login ref="child" :dialogLoginShow.sync="dialogLoginShow"></dialog-login>
  </header>
</template>

<script>
import DialogLogin from "../components/DialogLogin.vue";

export default {
  name: "Header",
  components: { DialogLogin },
  data() {
    return {
      aa: "../../public/logo.png",
      drawer: false,
      activeIndex2: "1",
      dialogLoginShow: false,
      isLogin: false,
      language: "",
      language_options: [
        { label: "繁體中文", value: "zh-TW" },
        // { label: "简体中文", value: "zh-CN" },
        { label: "English", value: "en" },
        // { label: "한국어", value: "ko" },
        // { label: "日本語", value: "ja" }
      ]
    };
  },
  mounted() {
    //檢查語言，如果不是這五種語言強制轉為英文
    let language = navigator.language || "en";
    if (language == "zh-TW" || language == "zh-CN" || language.indexOf("en") > -1 || language == "ko" || language == "ja") {
      if (language.indexOf("en") > -1) {
        language = "en";
      }

      console.log(language);
      this.languageChange(language);
    }
  },
  methods: {
    showLoginDialog() {
      if (this.$store.state.role == "admin") {
        this.$routerTo("/Admin");
        this.drawer = false;
        return false;
      }
      this.drawer = false;
      this.dialogLoginShow = true;
      this.$nextTick(() => {
        console.log(this.$refs.child.$refs.account.focus());
      });
    },
    async languageChange(val) {
      this.language = val;
      this.$i18n.locale = val;
      this.$store.commit("setLang", val);
      this.drawer = false;
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.el-select-dropdown {
  top: 128px !important;
}
</style>
